var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6755 12.4258L18.1161 13.8349C20.0292 14.9394 20.6847 17.3858 19.5802 19.299L15.5802 26.2272C14.4756 28.1403 12.0292 28.7958 10.1161 27.6913L8.38402 26.6913C6.47085 25.5867 5.81535 23.1403 6.91992 21.2272L8.91992 17.7631",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3248 18.5742L13.8842 17.1651C11.971 16.0606 11.3155 13.6142 12.4201 11.701L16.4201 4.77282C17.5246 2.85965 19.971 2.20415 21.8842 3.30872L23.6162 4.30872C25.5294 5.41329 26.1849 7.85965 25.0803 9.77282L23.0803 13.2369",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.3f9e9b415f81a01d0c080087b313683d.svg";
export { ForwardRef as ReactComponent };